<div
  class="accordion"
  [class.accordion--open]="isOpen()"
  [class.accordion--valid]="isValid()"
  [class.accordion--error]="hasError()"
>

  <!-- ── Header ──────────────────────────────────────────────────────── -->
  <button
    type="button"
    class="accordion__header"
    [class.accordion__header--open]="isOpen()"
    [class.accordion__header--error]="hasError()"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-controls]="'accordion-body-' + category.key"
    (click)="toggle()"
  >
    <span class="accordion__title">{{ category.title }}</span>

    <div class="accordion__header-right">
      <!-- Badge di errore -->
      @if (hasError()) {
        <span class="accordion__badge accordion__badge--error" aria-label="Sezione con errori">
          X
        </span>
      }

      <!-- Badge di validità -->
      @if (isValid()) {
        <span class="accordion__badge accordion__badge--valid" aria-label="Sezione completata">
          ✓
        </span>
      }

      <!-- Badge di caricamento -->
      @if (isPending()) {
        <span class="accordion__badge accordion__badge--loading" aria-label="Validazione in corso">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" class="spinner"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
        </span>
      }

      <!-- Freccia -->
      <svg
        class="accordion__arrow"
        [class.accordion__arrow--open]="isOpen()"
        xmlns="http://www.w3.org/2000/svg"
        width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2.5"
        stroke-linecap="round" stroke-linejoin="round"
        aria-hidden="true"
      >
        <polyline points="6 9 12 15 18 9"/>
      </svg>
    </div>
  </button>

  <!-- ── Body (con animazione CSS grid) ──────────────────────────────── -->
  <div
    class="accordion__body"
    [class.accordion__body--open]="isOpen()"
    [id]="'accordion-body-' + category.key"
    role="region"
    [attr.aria-labelledby]="'accordion-header-' + category.key"
  >
    <div class="accordion__body-inner" [formGroup]="categoryGroup()">

      <!-- Campi -->
      <div
        class="accordion__fields"
        [class.accordion__fields--one-element]="isSingleField() || category.singleColumn"
        [class.accordion__fields--compact]="isCompactSingleField()"
      >
        @for (item of fieldsWithControls(); track item.field.key) {
          <div
            #fieldWrapper
            class="accordion__field-wrapper"
            [class.accordion__field-wrapper--full]="isFullWidth(item.field)"
          >
            <app-field-renderer
              [field]="item.field"
              [control]="item.control"
            />
          </div>
        }
      </div>

      <!-- Messaggio errore categoria (sempre visibile se presente per feedback immediato) -->
      @if (categoryErrors()) {
        <div class="accordion__category-error">
          <span class="field-error" role="alert" aria-live="polite">
            {{ categoryErrors() | validationMessage }}
          </span>
        </div>
      }

    </div>
  </div>

</div>
